import type { PublicSpeakerUserSignupWithMeeting } from '@govinity/validation/public';

import { ReadOnlyApi } from './base';

export const PATH = '/public-speakers';

class PublicSpeakersApi extends ReadOnlyApi<PublicSpeakerUserSignupWithMeeting, never> {
  getPath() {
    return PATH;
  }
}

export default new PublicSpeakersApi();
